import { CaseReturnRequestType, CaseStatus, CaseType } from '@onrunning/backstage-models';
import { CasePickupModel } from './case-pickup.model';

export class CaseHeader {
  public id: string;
  public caseNumber: string;
  public accountId: string;
  public contactId: string;
  public type: CaseType;
  public status: CaseStatus;
  public createdAt: Date;
  // public subject: string;
  public description?: string;
  public creditNoteNumber?: string;

  // for return type:
  public itemsTotalQuantity?: number;
  public reason: string;
  public refundStatus?: string;
  public pickup?: CasePickupModel;
  public requestType?: CaseReturnRequestType;
  public parcelCount?: number;
  public palletCount?: number;

  // for warranty type:
  public itemsOpen?: number;
  public itemsApproved?: number;
  public itemsDeclined?: number;
  public isRefund: boolean;
}
